import createCrudModule from '@/utils/createCrudModule'

export default createCrudModule({
  resource: 'paymentSetupIntents',
  urlRoot: '/payment_setup_intents'
})
